/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.125.1-v202606250147-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import * as models from './models';

/**
 * The ordered path of items that led to the error. For example, it could contain an Analysis, then a relationship saying the Analysis has a Worksheet, then said Worksheet, then a relationship saying this worksheet has a Signal in its Journal, and then the id field in this error would be said Signal.
 */
export interface LockErrorPathOutputV1 {
    /**
     * The relationship the item has to its direct child in the path
     */
    "childRelationship"?: ChildRelationshipEnum;
    /**
     * The id of the item in the path
     */
    "id"?: string;
    "item"?: models.BaseOutput;
}

export enum ChildRelationshipEnum {
    CURRENTWORKSTEPINAWORKSHEET = 'CURRENT_WORKSTEP_IN_A_WORKSHEET',
    WORKSHEET = 'WORKSHEET',
    SCOPEDTO = 'SCOPED_TO',
    HASINTEREST = 'HAS_INTEREST',
    INTERESTEDIN = 'INTERESTED_IN',
    MONITOREDBY = 'MONITORED_BY',
    MONITORS = 'MONITORS',
    REFERENCEDBYJOURNALINWORKSHEET = 'REFERENCED_BY_JOURNAL_IN_WORKSHEET',
    REFERENCEDBYWORKSTEP = 'REFERENCED_BY_WORKSTEP',
    POSSIBLECHILD = 'POSSIBLE_CHILD',
    NOREADPERMISSION = 'NO_READ_PERMISSION',
    NOWRITEPERMISSION = 'NO_WRITE_PERMISSION',
    NOMANAGEPERMISSION = 'NO_MANAGE_PERMISSION',
    HASPARAMETER = 'HAS_PARAMETER'
}
